import React from 'react';
import styles from './ClearAllButton.module.scss';
import { CalciteButton } from '@esri/calcite-components-react';

type clearProps = {
  handleClick: (event: React.MouseEvent) => void,
}

const ClearAllButton = ({handleClick}: clearProps) => (
  <CalciteButton className={styles.ClearAllButton} color='blue' appearance='outline' iconStart='reset' onClick={handleClick}>Clear All</CalciteButton>
);

export default ClearAllButton;